var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable dot-notation */
import { datadogLogs } from '@datadog/browser-logs';
import { useEffect } from 'react';
import { execJsInSdk, logError } from '../integration-utils';
import sleep from '../../../../utils/sleep';
import { postParentWindowMessage } from '../../../../utils/post-message';
function _initializePinwheelContext() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, execJsInSdk(function () {
                        if (!window['_pwcx'])
                            window['_pwcx'] = {};
                        window['setPwcx'] = function (k, v) {
                            var _a, _b, _c;
                            window['_pwcx'][k] = v;
                            // Below fires a message from the payroll DOM to the iOS sdk
                            (_c = (_b = (_a = window['webkit']) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.pwcxHandler) === null || _c === void 0 ? void 0 : _c.postMessage({
                                k: k,
                                v: v,
                            });
                        };
                    }, 'set_pwcx')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export var checkLoaded = function () { return !!document.querySelector('input'); };
export function checkLoadedAndShow(timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = 5000; }
    return __awaiter(this, void 0, void 0, function () {
        var isLoaded, initTime;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoaded = false;
                    initTime = Date.now();
                    _a.label = 1;
                case 1:
                    if (!!isLoaded) return [3 /*break*/, 5];
                    return [4 /*yield*/, execJsInSdk(checkLoaded, 'check_loaded')];
                case 2:
                    isLoaded = _a.sent();
                    if (Date.now() - initTime > timeoutMs)
                        return [3 /*break*/, 5];
                    if (!!isLoaded) return [3 /*break*/, 4];
                    return [4 /*yield*/, sleep(1)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 1];
                case 5:
                    if (isLoaded) {
                        datadogLogs.logger.info('client_integration_load_success', {
                            timeToSuccessMs: Date.now() - initTime,
                        });
                    }
                    else {
                        datadogLogs.logger.warn('client_integration_load_timeout', { timeoutMs: timeoutMs });
                    }
                    return [4 /*yield*/, _initializePinwheelContext()];
                case 6:
                    _a.sent();
                    postParentWindowMessage({
                        type: 'PINWHEEL_INTERNAL_COMM_UP',
                        eventName: 'browser_visibility',
                        payload: { visible: true },
                    });
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Shows the webview when the page is presenting a login form.
 *
 * Determines if the DOM has loaded the login page by checking for
 * an input field on new page load. Use this hook for web applications
 * that change the page URL on login success. If the URL remains the
 * same on login success, use `useCheckLoadedAndShowSPA`.
 *
 * @param cb - Optional callback to fire after the page is loaded
 */
export function useCheckLoadedAndShow(cb) {
    var _this = this;
    useEffect(function () {
        void Promise.resolve().then(function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, checkLoadedAndShow()];
                    case 1:
                        _a.sent();
                        if (!cb) return [3 /*break*/, 3];
                        return [4 /*yield*/, cb()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        logError(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); });
    }, [cb]);
}
